// Styles for PointsCard go here.
import styled from 'styled-components';
export const StyledPointsCard = styled.div``;
